import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from './i18n'

// 创建应用实例
const app = createApp(App)

// 注册插件
app.use(createPinia())
app.use(router)
app.use(i18n)

// Element Plus 语言包由 App.vue 中的 el-config-provider 动态控制
app.use(ElementPlus)

// 挂载应用
app.mount('#app')
